module.exports = __webpack_public_path__ + "static/media/softPicOne.6c9e81b9.jpg";